import {
  CART_LOGIN_REDIRECT_EXPERIMENT_NAME,
  PDP_HIDE_OVERVIEW_EXPERIMENT_NAME,
  PERCENTAGE_OFF_PRICING_EXPERIMENT_NAME,
} from '@/constants/global';

const initialState = () => ({
  [CART_LOGIN_REDIRECT_EXPERIMENT_NAME]: 'disabled',
  [PDP_HIDE_OVERVIEW_EXPERIMENT_NAME]: 'control',
  [PERCENTAGE_OFF_PRICING_EXPERIMENT_NAME]: 'control',
});

// for accurate conversion rate tracking whitelist the pages your experiment is applicable
const EXPERIMENT_WHITELIST = {};

export { initialState as state };

export const getters = {
  getExperimentVariant: (state) => (experimentKey) => (
    state?.[experimentKey]
  ),
};

export const mutations = {
  set(state, data) {
    Object.keys(data).forEach((key) => {
      state[key] = data[key]; // eslint-disable-line no-param-reassign
    });
  },
};

export const actions = {
  async enroll({ commit }) {
    const isWhitelisted = (rules) => !!rules.find(
      (rule) => this.$router.currentRoute.fullPath.match(rule),
    );

    // experiments to enroll in
    const experimentKeys = [
      CART_LOGIN_REDIRECT_EXPERIMENT_NAME,
      PDP_HIDE_OVERVIEW_EXPERIMENT_NAME,
      PERCENTAGE_OFF_PRICING_EXPERIMENT_NAME,
    ];

    const promises = [];
    experimentKeys.forEach((experimentKey) => {
      // add all experiments to run if they are whitelisted or if there is no whitelist
      const whitelist = EXPERIMENT_WHITELIST[experimentKey];

      promises.push(whitelist && !isWhitelisted(whitelist)
        ? Promise.resolve(undefined) : this.$experiments.enroll(experimentKey));
    });

    const state = {};
    const results = await Promise.all(promises);
    // process results and set any that are not undefined
    results.forEach((result, index) => {
      const experimentKey = experimentKeys[index];

      if (result !== undefined) {
        state[experimentKey] = result;
      }
    });

    if (Object.keys(state).length > 0) {
      commit('set', state);
    }
  },

  async enrollByName({ commit }, name) {
    const experimentValue = await this.$experiments.enroll(name);

    commit('set', { [name]: experimentValue });
  },
};
